import React, { createContext, useMemo, useState } from "react";

interface INotification {
  id: string;
  type: string;
  message: string;
}

interface INotificationContextProps {
  notifications: INotification[];
  addNotification: (type: string, message: string) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
}
interface INotificationProviderProps {
  children: React.ReactNode;
}

export const NotificationContext = createContext<INotificationContextProps>({
  notifications: [],
  addNotification: () => {},
  removeNotification: () => {},
  clearNotifications: () => {},
});

export const NotificationProvider: React.FC<INotificationProviderProps> = ({
  children,
}) => {
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const addNotification = (type: string, message: string) => {
    const id = crypto.randomUUID(); // cryptographically secure unique id
    const newNotification: INotification = { id, type, message };

    setNotifications((prev) => [...prev, newNotification]);
    window.scroll(0, 0);

    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 5000);
  };

  const removeNotification = (id: string) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
    window.scroll(0, 0);
  };
  const clearNotifications = () => {
    setNotifications([]);
    window.scroll(0, 0);
  };

  const notificationContextValue = useMemo(() => {
    return {
      notifications,
      addNotification,
      removeNotification,
      clearNotifications,
    };
  }, [notifications, addNotification, removeNotification, clearNotifications]);

  return (
    <NotificationContext.Provider value={notificationContextValue}>
      {children}
    </NotificationContext.Provider>
  );
};
